// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3hLX{position:relative;flex-direction:column}._3hLX,._2oN_{display:flex}._3acY{margin-bottom:.8rem}._27Fo{position:relative}._2tZs{flex:1;padding:.4em 3em .4em .6em;border:1px solid #373737;-webkit-appearance:none;-moz-appearance:none;appearance:none}._3Vkd{position:absolute;top:0;bottom:0;right:1.5rem;margin:auto;pointer-events:none}html[dir=rtl] ._2tZs{padding:.4em .6em .4em 3em}html[dir=rtl] ._3Vkd{right:auto;left:1.5rem}", ""]);
// Exports
exports.locals = {
	"root": "_3hLX",
	"wrapper": "_2oN_",
	"label": "_3acY",
	"select": "_27Fo",
	"input": "_2tZs",
	"chevron": "_3Vkd"
};
module.exports = exports;
